export const W8_W9_PAYMENT_MODAL_LOADING_STATES = {
    GET_W8_FORMS_LOADING: "GET_W8_FORMS_LOADING",
    GET_W8_FORMS_READY: "GET_W8_FORMS_READY",
    GET_W8_W9_FEES_LOADING: "GET_W8_W9_FEES_LOADING",
    GET_W8_W9_FEES_READY: "GET_W8_W9_FEES_READY",
    DISPLAY_PLANS_VIEW_LOADING: "DISPLAY_PLANS_VIEW_LOADING",
    DISPLAY_PLANS_VIEW_READY: "DISPLAY_PLANS_VIEW_READY",
}